<template>
  <va-modal
    id="bulkUpdateEntityActivityUser"
    size="large"
    :value="showModal"
    :noOutsideDismiss="true"
    :okText="$t('modals.buttons.save')"
    :cancelText="$t('modals.buttons.cancel')"
    :okDisabled="isSubmitting || !canSubmitForm"
    @ok="submit"
    @cancel="cancel">

    <div slot="header" class="modal-title">
      {{ $t('entities.activities.revision.title')}}
    </div>

    <span></span>

    <LoadingAnimation v-if="isLoading" class="d-flex justify-content-center p-5" />

    <div class="appointment" v-else-if="appointmentsWithoutActivity.length">

      <div class="label-info">
        <span>{{ getModalBody }}</span>
      </div>
      <div class="label-info">
        {{ $t('entities.activities.first_start') }}:&nbsp;<span>{{ firstStart }}</span>
      </div>

      <div class="label-info">
        {{ $t('entities.activities.last_end') }}:&nbsp;<span>{{ lastEnd }}</span>
      </div>

      <div class="label-info" v-if="filteredEntitiesActivitiesUsers.length">
        <span></span>
        <span>{{ $t('entities.activities.revision.replace_body') }}{{isUpdating ? $t('entities.activities.revision.replace_body_operation_update') : $t('entities.activities.revision.replace_body_operation_delete')}} </span>
        <div class="list">
          <div
            v-for="(_entityActivityUser, index) in filteredEntitiesActivitiesUsers"
            :key="_entityActivityUser.id">

            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex justify-content-start align-items-center">
                <va-radio-button
                  :option="_entityActivityUser"
                  v-model="selectedEntityActivityUser"
                  :label="' '"
                />

                <EntityActivityUserInfo
                  class="mt-2"
                  :entityActivityUser="_entityActivityUser"
                  @click.native="select(_entityActivityUser)"
                  />
              </div>

                <LoadingAnimation
                  class="mr-5"
                  size="2.5rem"
                  v-if="isSubmitting && selectedEntityActivityUser && _entityActivityUser.id === selectedEntityActivityUser.id">
                </LoadingAnimation>
            </div>

            <hr v-if="index !== entitiesActivitiesUsers.length - 1">
          </div>
        </div>
      </div>
      <div v-else class="d-flex justify-content-center mt-5 label-info">
        <span>{{ $t('entities.activities.revision.no_replace_found')}}</span>
      </div>
    </div>

  </va-modal>
</template>
<script>
import LoadingAnimation from '@/components/common/LoadingAnimation'
import EntityActivityUserInfo from '@/components/entity-activity-user/EntityActivityUserInfo'
import { AppointmentService } from '@/api/AuthClinicalService'
import { ActivityService, EntityActivityUserService } from '@/api/AuthService'
const ActivityInfoType = 140
const AuthService = 6

export default {
  props: {
    isUpdating: {
      type: Boolean,
      required: true
    },
    updatingFormData: {
      type: Object,
      required: false
    },
    selectedActivity: {
      type: Object,
      required: false
    },
    entityActivityUser: {
      type: Object,
      required: true
    }
  },
  components: {
    LoadingAnimation,
    EntityActivityUserInfo
  },
  data () {
    return {
      showModal: false,
      isSubmitting: false,
      isLoading: true,
      appointments: [],
      entitiesActivitiesUsers: [],
      selectedEntityActivityUser: null
    }
  },
  created () {
    this.loadAppointments()
      .then(() => this.loadEntityActivityUsers())
      .then(() => (this.isLoading = false))
  },
  mounted () {
    this.toggleModalVisibility()
  },
  methods: {
    loadAppointments: function () {
      return new Promise((resolve, reject) => {
        let params = {
          orderBy: 'start',
          ascending: 'asc'
        }
        AppointmentService.getByEntityActivityUser(this.$store.state.auth_clinical_server, this.entityActivityUser.id, params)
          .then(appointments => {
            appointments = appointments.map(appointment => {
              return {
                ...appointment,
                start: this.$options.filters.localTime(appointment.start),
                end: this.$options.filters.localTime(appointment.end)
              }
            })
            this.appointments = appointments
            resolve()
          }).catch(errors => {
            reject(errors)
          })
      })
    },
    loadEntityActivityUsers: function () {
      return new Promise((resolve, reject) => {
        let params = {
          inclusive: false,
          infoType: ActivityInfoType,
          serviceId: AuthService,
          entities: this.entityActivityUser.entity.id,
          start: this.firstStart,
          end: this.lastEnd,
          activities: this.entityActivityUser.activity.id
        }
        ActivityService.getActivityUsersByEntity(params)
          .then(entityActivityUsers => {
            this.entitiesActivitiesUsers = entityActivityUsers
            resolve()
          }).catch(errors => {
            reject(errors)
          })
      })
    },
    toggleModalVisibility: function () {
      this.showModal = !this.showModal
    },
    select: function (entityActivityUser) {
      this.selectedEntityActivityUser = entityActivityUser
    },
    submit: function () {
      this.isSubmitting = true
      this.updateAppointments()
        .then(() => this.isUpdating ? this.updateEntityActivityUser() : this.destroyEntityActivityUser())
        .then(() => {
          this.showToast(this.$t('entities.activities.revision.appointments_updated'), this.$store.state.successToastOptions)
          this.isUpdating ? this.showToast(this.$t('entities.activities.updated'), this.$store.state.successToastOptions) : this.showToast(this.$t('entities.activities.deleted'), this.$store.state.successToastOptions)
          this.$emit('updated')
        })
        .catch(errors => {
          console.log('errors', errors)
          this.showToast(this.$t('entities.activities.revision.error'), this.$store.state.errorToastOptions)
        }).finally(() => {
          this.isSubmitting = false
        })
    },
    cancel: function () {
      this.$emit('modal-canceled')
    },
    updateAppointments: function () {
      let params = {
        entity_activity_user_id: this.selectedEntityActivityUser.id
      }

      let promises = this.appointmentsWithoutActivity.map(appointment => {
        return AppointmentService.updateEntityActivityUser(this.$store.state.auth_clinical_server, appointment.id, params)
      })

      return Promise.all(promises)
    },
    destroyEntityActivityUser: function () {
      return EntityActivityUserService.delete(this.entityActivityUser.id)
    },
    updateEntityActivityUser() {
      return EntityActivityUserService.update(this.selectedActivity.id, this.updatingFormData)
    }
  },
  computed: {
    getModalBody: function () {
      if (this.appointmentsWithoutActivity.length > 1) {
        return `${this.$t('entities.activities.revision.multiple_review', { number: this.appointmentsWithoutActivity.length })}.`
      } else if (this.appointmentsWithoutActivity.length === 1) {
        return `${this.$t('entities.activities.revision.single_review')}.`
      }
    },
    canSubmitForm: function () {
      return this.selectedEntityActivityUser !== null
    },
    filteredEntitiesActivitiesUsers: function () {
      return this.entitiesActivitiesUsers.filter(_entityActivityUser => _entityActivityUser.id !== this.entityActivityUser.id)
    },
    appointmentsWithoutActivity: function () {
      if (this.isUpdating && this.updatingFormData) {
        return this.appointments.filter(appointment => this.moment(appointment.end).isAfter(this.moment(this.updatingFormData.end_date)) || this.moment(appointment.start).isBefore(this.moment(this.updatingFormData.start_date)))
      }
      return this.appointments.filter(appointment => this.moment(appointment.end).isSameOrAfter())
    },
    futureAppointments: function () {
      if (this.isUpdating && this.updatingFormData && this.updatingFormData.end_date) {
        return this.appointments.filter(appointment => this.moment(appointment.start).isSameOrAfter(this.moment(this.updatingFormData.end_date)))
      }
      return this.appointments.filter(appointment => this.moment(appointment.start).isSameOrAfter())
    },
    firstStart: function () {
      return this.appointmentsWithoutActivity.length ? this.appointmentsWithoutActivity[0].start : null
    },
    lastEnd: function () {
      return this.appointmentsWithoutActivity.length ? this.appointmentsWithoutActivity[this.appointmentsWithoutActivity.length - 1].end : null
    }
  }
}
</script>
<style lang="scss">
.appointment {
  & .label-info {
    margin-left: 0.5rem;
    margin-bottom: 0.7rem;
    color: #48494B;
    & span {
      font-weight: bold;
    }
  }
}
</style>
